<template>
  <DeleteServiceModal />
  <CreateServiceModal />
  <UpdateServiceModal />
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center justify-content-between gap-3 p-15 p-sm-20 p-md-25 radius-7">
      <div class="d-flex align-items-center">
        <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none"
          href="#" data-bs-toggle="modal" data-bs-target="#CreateServiceModal">
          <span class="d-none d-md-inline me-2">Criar novo serviço</span>
          <i class="flaticon-plus position-relative fs-12"></i>
        </a>
      </div>
      <div class="service-list-filters d-flex flex-column flex-sm-row align-items-sm-center gap-3 ms-lg-auto">
        <div class="service-category-filter">
          <label for="service_category_filter" class="visually-hidden">Filtrar serviços por categoria</label>
          <select id="service_category_filter" v-model="selectedCategoryId" class="form-select" @change="loadPage(1)">
            <option value="">Todas as categorias</option>
            <option v-for="category in getCategories" :key="category.id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="service-search-filter d-flex align-items-center" style="position: relative; z-index: 99;">
          <multiselect
            ref="serviceSelect"
            v-model="selectedSearchService"
            :options="filteredSearchServices"
            :searchable="true"
            :loading="isLoadingServices"
            :internal-search="false"
            :custom-label="formatServiceOption"
            :taggable="false"
            label="name"
            track-by="id"
            no-options-text="Nenhum serviço encontrado."
            no-result-text="Nenhum resultado para sua busca."
            placeholder="Buscar serviço..."
            @search-change="debouncedFetchServices"
            @select="onServiceSelect"
            :close-on-select="true"
            id="service_search"
            class="w-100"
          >
            <template #noOptions>
              <div>Comece a digitar para buscar serviços.</div>
            </template>
            <template #noResult>
              Nenhum serviço encontrado
            </template>
          </multiselect>
        </div>
      </div>
    </div>





    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Serviço
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Categoria
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Subcategoria
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Valor
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Tempo de execução
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Editar
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Deletar
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isLoadingServiceList || serviceListError || !getServiceList.length">
              <td colspan="7" class="text-center text-muted py-4" role="status">
                {{ isLoadingServiceList ? 'Carregando serviços...' : (serviceListError || 'Nenhum serviço encontrado para esta categoria.') }}
              </td>
            </tr>
            <template v-else>
              <tr v-for="(value, key) in getServiceList" :key="key">

                <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                      {{ value.name }}
                    </div>
                  </div>
                </th>

                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ value.category.name }}
                </td>

                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ value.subcategory?.name || '-' }}
                </td>

                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ value.price_type === 'STARTING_AT' ? 'A partir de ' : '' }}R$ {{ value.price_formatted }}
                </td>

                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ formatTime(value.time) }}
                </td>

                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                  <button v-on:click="setCurrentUpdateService(value)" data-bs-toggle="modal"
                    data-bs-target="#UpdateServiceModal"
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                  </button>
                </td>

                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                  <button v-on:click="setCurrentDeleteService(value)" data-bs-toggle="modal"
                    data-bs-target="#DeleteServiceModal"
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                    <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                  </button>
                </td>

              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getServicesPagination.last_page ? getServicesPagination.last_page : 1 }} —
          Total de {{ getServicesPagination.total ? getServicesPagination.total : (getServiceList ?
            getServiceList.length : 0) }} serviços
        </div>
        <nav aria-label="Paginação de serviços">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="isLoadingServiceList || !!serviceListError || currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item"
              :class="{ disabled: currentPage >= (getServicesPagination.last_page ? getServicesPagination.last_page : 1) }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)"
                :disabled="isLoadingServiceList || !!serviceListError || currentPage >= (getServicesPagination.last_page ? getServicesPagination.last_page : 1)">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import DeleteServiceModal from './DeleteServiceModal.vue';
import CreateServiceModal from './CreateServiceModal.vue';
import UpdateServiceModal from './UpdateServiceModal.vue';

export default defineComponent({
  name: "ServicesList",
  data() {
    return {
      currentPage: 1,
      selectedCategoryId: '' as string | number,
      isLoadingServiceList: false,
      serviceListError: '',
      serviceListRequestId: 0,
      selectedSearchService: null,
      isLoadingServices: false,
      lastServiceQuery: '',
      serviceFetchTimer: null,
      pendingServiceQuery: ''
    };
  },
  computed: {
    ...mapGetters([
      "getServiceList",
      "getServicesPagination",
      "getSearchedServices",
      "getCategories"
    ]),
    filteredSearchServices(): any[] {
      if (this.selectedCategoryId === '') return this.getSearchedServices;
      return this.getSearchedServices.filter((service: any) =>
        String(service.category_id ?? service.category?.id) === String(this.selectedCategoryId)
      );
    }
  },
  components: {
    DeleteServiceModal,
    CreateServiceModal,
    UpdateServiceModal,
    Multiselect
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    ...mapActions([
      "setCurrentUpdateService",
      "setCurrentDeleteService",
      "fetchServiceList",
      "setSearchServicesList"
    ]),
    formatServiceOption(service: any) {
      if (!service) return '';
      return `${service.name} - R$ ${service.price}`;
    },
    async fetchServicesSearch(query: string) {
      if (!query || query.length < 2 || query === this.lastServiceQuery) return;

      this.lastServiceQuery = query;
      this.isLoadingServices = true;

      try {
        await this.setSearchServicesList(query);
      } catch (error) {
        console.error('Erro ao buscar serviços:', error);
      } finally {
        this.isLoadingServices = false;
      }
    },
    debouncedFetchServices(query: string) {
      this.pendingServiceQuery = query;

      if (this.serviceFetchTimer) {
        clearTimeout(this.serviceFetchTimer as any);
      }

      this.serviceFetchTimer = setTimeout(() => {
        this.fetchServicesSearch(this.pendingServiceQuery);
        this.serviceFetchTimer = null;
      }, 600) as any;
    },
    onServiceSelect(service: any) {
      this.setCurrentUpdateService(service);

      this.$nextTick(() => {
        const modalEl = document.getElementById('UpdateServiceModal');
        if (!modalEl) return;
        
        if (window.bootstrap && window.bootstrap.Modal) {
          try {
            const modalInstance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
            modalInstance.show();
          } catch(e) {
            let btn = document.createElement('button');
            btn.setAttribute('data-bs-toggle', 'modal');
            btn.setAttribute('data-bs-target', '#UpdateServiceModal');
            document.body.appendChild(btn);
            btn.click();
            document.body.removeChild(btn);
          }
        } else {
          let btn = document.createElement('button');
          btn.setAttribute('data-bs-toggle', 'modal');
          btn.setAttribute('data-bs-target', '#UpdateServiceModal');
          document.body.appendChild(btn);
          btn.click();
          document.body.removeChild(btn);
        }
        
        // Limpar a busca
        this.selectedSearchService = null;
      });
    },
    formatTime(time: any) {
      return moment(time, 'HH:mm:ss').format('HH:mm');
    },
    async loadPage(page: number) {
      if (!page || page < 1) {
        page = 1;
      }
      this.currentPage = page;
      const requestId = ++this.serviceListRequestId;
      this.isLoadingServiceList = true;
      this.serviceListError = '';
      try {
        await this.fetchServiceList({ page, category_id: this.selectedCategoryId });
      } catch (error) {
        if (requestId === this.serviceListRequestId) {
          this.serviceListError = 'Não foi possível carregar os serviços. Selecione a categoria para tentar novamente.';
        }
      } finally {
        if (requestId === this.serviceListRequestId) this.isLoadingServiceList = false;
      }
    },
    goToPage(page) {
      if (page < 1 || (this.getServicesPagination.last_page && page > this.getServicesPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    }
  }
});
</script>

<style scoped>
.service-list-filters {
  width: 100%;
  max-width: 630px;
}

.service-category-filter {
  flex: 1 1 0;
  min-width: 0;
}

.service-search-filter {
  flex: 1.25 1 0;
  min-width: 0;
}
</style>
